import { Component, OnInit } from '@angular/core';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { ToastrService } from 'ngx-toastr';
import { OSService } from 'src/app/services/os-service';
import { UsuarioService } from 'src/app/services/usuario.service';
import { ParametersOS } from '../domain/viewmodels.models';

@Component({
  selector: 'app-tratar-osavaliada',
  templateUrl: './tratar-osavaliada.component.html',
  styleUrls: ['./tratar-osavaliada.component.scss']
})
export class TratarOSAvaliadaComponent implements OnInit {

  constructor(
    private osService: OSService,
    private toastr: ToastrService,
    private modalService: NgbModal,
    private usuarioService: UsuarioService,
    private osservice: OSService,

  ) { }

  ngOnInit() {
    this.getOSsParaAvaliar();
  }

  public resultadosPesquisa: any[] = [];
  public nenhumResultado = false;
  public isProcessing: boolean = false;
  parameters: ParametersOS;
  public osIdSelected: any;
  public msgQuestion: string = "";
  public tipoActionModal: string = "";


  reset() {
    this.resultadosPesquisa = [];
    this.nenhumResultado = false;

  }

  getOSsParaAvaliar() {
    this.reset();

    this.osservice.getOSparaAvaliar().subscribe(
      (response) => {
        this.resultadosPesquisa = response;

        if (this.resultadosPesquisa.length === 0) {
          this.nenhumResultado = true;
        }
        this.isProcessing = false;
      },
      (err: any) => {
        this.toastr.error(err, "Ocorreu um erro ao tentar fazer a pesquisa");
        this.isProcessing = false;
        this.reset();
      }
    );


  }

  getById(id, spvId,  modal) {

    this.parameters = {osId : id, spvId : spvId};

    console.log(id, spvId, modal);

  }

  cancelarOSEmitter(osId, modal: any) {
    
    this.osIdSelected = osId;
    this.tipoActionModal = "cancelar";
    this.msgQuestion = `<b>OS nº ${this.osIdSelected}</b><br />Deseja <b>cancelar</b> essa OS?`;
    this.modalService.open(modal, { windowClass: 'sm', backdrop: 'static' })
  }

  qualificarOSEmitter(osId, modal: any) {
    
    this.osIdSelected = osId;
    this.tipoActionModal = "qualificar";
    this.msgQuestion = `<b>OS nº ${this.osIdSelected}</b><br />Deseja <b>liberar</b> essa OS para execução?`;
    
    this.modalService.open(modal, { windowClass: 'sm', backdrop: 'static' })
  }


  actionModal(c: any) {

    if (this.tipoActionModal === 'cancelar') this.cancelar(c);
    if (this.tipoActionModal === 'qualificar') this.qualificar(c);

  }


  public cancelar(c: any): void {
    this.isProcessing = true
    c('Close click')

    this.osService.cancelarOS(this.osIdSelected).subscribe(
      (response: any) => {

        if (response == true) {
          this.getOSsParaAvaliar();
          this.toastr.success('OS cancelada com sucesso');
          
          this.modalService.dismissAll();
          this.isProcessing = false;
          this.parameters = null;
        } else {
          this.toastr.error("Ocorreu um erro ao tentar cancelar a OS")
          this.isProcessing = false;
        }
    });
  }

  public qualificar(c: any): void {
    this.isProcessing = true
    c('Close click')

    this.osService.qualificarOS(this.osIdSelected).subscribe(
      (response: any) => {

        if (response == true) {
          this.getOSsParaAvaliar();
          this.toastr.success('OS Qualificada com sucesso');
         
          this.modalService.dismissAll();
          this.isProcessing = false;
          this.parameters = null;
        } else {
          this.toastr.error("Ocorreu um erro ao tentar cancelar a OS")
          this.isProcessing = false;
        }
    });
  }





}
